import { Button } from '@/components/ui/button';

const EmptyState = ({
  onActionClick,
  actionText,
  title,
  description,
}: {
  onActionClick?: () => void;
  actionText?: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div
        className="flex flex-1 items-center p-6 justify-center rounded-lg border border-dashed shadow-sm"
        x-chunk="dashboard-02-chunk-1">
        <div className="flex flex-col items-center gap-1 text-center">
          <h3 className="text-2xl font-bold tracking-tight">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
          {onActionClick && (
            <Button className="mt-4" onClick={onActionClick} variant="outline">
              {actionText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
